// The shapes every language folder shares (8 October 2026). See README.md.

/** The languages the console offers. Add a code here, to LOCALES and to CATALOGS in catalog.ts to offer a new one. */
export type Locale = 'en' | 'af' | 'zu' | 'xh' | 'st';

/** One language's text: key to translated string. */
export type Catalog = Record<string, string>;

/** The language picker, in the order shown; `label` is the language's own name. */
export const LOCALES: { code: Locale; label: string; english: string }[] = [
  { code: 'en', label: 'English', english: 'English' },
  { code: 'af', label: 'Afrikaans', english: 'Afrikaans' },
  { code: 'zu', label: 'isiZulu', english: 'Zulu' },
  { code: 'xh', label: 'isiXhosa', english: 'Xhosa' },
  { code: 'st', label: 'Sesotho', english: 'Sotho' }
];
